export const parkizaSystemStatusKeys = {
  all: ["parkiza-system-status"] as const,
};
